export const TEST_ID = {
  appHeader: 'appHeader',
  appHeaderLogo: 'appHeaderLogo',
  appHeaderProfileAvatar: 'appHeaderProfileAvatar',
  appHeaderNotifications: 'appHeaderNotifications',
  notificationAvailableBadge: 'notificationAvailableBadge',
  notificationOptionsButton: 'notificationOptionsButton',
  batchNotificationOptionsButton: 'batchNotificationOptionsButton',
};
